import { cn } from '@core-utils/cn';
import Image from 'next/image';

import errorIcon from './icons/error_icon.svg';
import { alertBannerStyles as styles } from './styles';
import { Alert } from './types';

const iconsConfig = {
    error: errorIcon,
    warning: errorIcon,
    info: errorIcon,
};

const blockModifiers = {
    error: styles.errorAlert,
    warning: styles.warningAlert,
    info: styles.infoAlert,
};

const handleRefreshClick = (e: { preventDefault: () => void }) => {
    window.location.reload();
    e.preventDefault();
};

type Props = Alert;

export function AlertBanner({
    type,
    message,
    isRefreshVisible,
    isExiting,
}: Props) {
    const alertIcon = iconsConfig[type];

    return (
        <div
            className={cn(
                styles.blockScope,
                blockModifiers[type],
                isExiting && styles.exitingAlert,
            )}
        >
            <p>
                <Image src={alertIcon} alt={`${type} alert icon`} />
                <span>{message}</span>
                {isRefreshVisible ? (
                    <>
                        <a href="#" onClick={handleRefreshClick}>
                            Refresh
                        </a>
                    </>
                ) : null}
            </p>
        </div>
    );
}
